import { render, staticRenderFns } from "./SizeList.vue?vue&type=template&id=7048f152&scoped=true&"
import script from "./SizeList.vue?vue&type=script&lang=js&"
export * from "./SizeList.vue?vue&type=script&lang=js&"
import style0 from "./SizeList.vue?vue&type=style&index=0&id=7048f152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7048f152",
  null
  
)

export default component.exports